import { FC, type JSX } from 'react';

import RadioButtons from './RadioButtons';
import './SectionRadioButtons.sass';

type Props = {
  items: { label: string; value: string; altSelected?: boolean }[];
  onChange: (value: any) => void;
  title?: any;
  value: any;
};

const SectionRadioButtons: FC<Props> = ({
  items,
  onChange,
  title,
  value,
}: Props): JSX.Element => {
  return (
    <div style={{ position: 'relative' }} className="section-radio-buttons">
      <div>
        <label className="additional-label">{title}</label>
      </div>
      <div className="radio-button-wrapper">
        <RadioButtons items={items} value={value} onChange={onChange} />
      </div>
    </div>
  );
};

export default SectionRadioButtons;
